import { deserialise } from "kitsu-core";

import { ApiKey } from "../ApiKey";
import { FetchConfig } from "../FetchConfig";
import { FetchAdapter } from "../FetchAdapter/FetchAdapter";
import { BugsnagAdapter } from "../BugsnagAdapter/BugsnagAdapter";
import { VidioApi } from "shared/vidio_helpers";

class JsonApiAdapter {
  static async fetchApi(path, options = {}) {
    const config = await JsonApiAdapter.getApiHeaders(options);
    const url = JsonApiAdapter.generateUrl(path);

    return FetchAdapter.get(url, config)
      .then((response) => {
        return deserialise(response.json());
      })
      .catch((e) => {
        const err = e instanceof Error ? e : new Error(` is aborted`);
        BugsnagAdapter.notify("JsonApiAdapter::fetchApi", err, e);

        return { data: [] };
      });
  }

  static async rawFetchApi(path, options = {}) {
    const config = await JsonApiAdapter.getApiHeaders(options);
    const url = JsonApiAdapter.generateUrl(path);

    return FetchAdapter.rawFetch(url, config);
  }

  static async getApiHeaders(options = {}) {
    return new FetchConfig(options).attachHeaders({
      "X-API-KEY": await ApiKey.getToken(),
      "Content-Type": "application/vnd.api+json",
    });
  }

  static generateUrl(url) {
    try {
      new URL(url);
      return url;
    } catch (e) {
      return VidioApi.generateUrl(url);
    }
  }
}

export { JsonApiAdapter };
